import React, { useEffect, useContext, useState } from "react";
import Axios from "axios";
import AppContext from "../../../context/store";
import PerformanceReport from "./PerformanceReport";
import Select from "../../../theme/CustomMUI/Select";

const AnalysisIndex = () => {
  const context = useContext(AppContext);
  const [analyticsData, setAnalyticsData] = useState(null);
  const [analysisRecords, setAnalysisRecords] = useState([]);
  const [selectedRecordId, setSelectedRecordId] = useState(null);
  const [allRecordsData, setAllRecordsData] = useState([]);
  const [isRecords, setIsRecords] = useState(false);

  const fetchAnalysis = async () => {
    try {
      const response = await Axios.get(`${context.api_endpoint}/company/analytics/company/ai-analytics`);
      if (response.data?.data?.records) {
        const records = response.data.data.records.map(record => ({
          value: record.id,
          label: new Date(record.created_at).toLocaleDateString('tr-TR')
        }));
        setAnalysisRecords(records);
        setAllRecordsData(response.data.data.records);
        setIsRecords(records.length > 0);

        // Son kaydı seç
        if (records.length > 0) {
          const lastRecord = response.data.data.records[records.length - 1];
          const parsedAnalysis = JSON.parse(lastRecord.analysis);
          setSelectedRecordId(lastRecord.id.toString());
          setAnalyticsData(parsedAnalysis);
        }
      }
    } catch (error) {
      console.error("Analytics data fetch error:", error);
    }
  };

  useEffect(() => {
    fetchAnalysis();
  }, []);

  const handleAnalysisChange = (value) => {
    const selectedRecord = allRecordsData.find(record => record.id.toString() === value);
    if (selectedRecord) {
      const parsedAnalysis = JSON.parse(selectedRecord.analysis);
      setSelectedRecordId(value);
      setAnalyticsData(parsedAnalysis);
    }
  };

  return (
    <>
      {isRecords ? (
        <div style={{ padding: "20px" }}>
          {analyticsData && (
            <PerformanceReport
              data={analyticsData}
              analysisRecords={analysisRecords}
              selectedRecordId={selectedRecordId}
              onAnalysisChange={handleAnalysisChange}
            />
          )}
        </div>

      ) : (
        <div style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: "4rem 1rem"
        }}>
          <div style={{
            backgroundColor: "#f9fafb",
            borderRadius: "0.5rem",
            boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
            padding: "2rem",
            maxWidth: "28rem",
            width: "100%",
            textAlign: "center"
          }}>
            <img
              src={require("../../../assets/images/no-data-img.png")}
              alt="Veri bulunamadı"
              style={{
                margin: "0 auto",
                marginBottom: "1.5rem",
                width: "27rem",
                height: "auto",
                opacity: "0.8"
              }}
            />
            <h3 style={{
              fontSize: "1.125rem",
              fontWeight: "500",
              color: "#1f2937",
              marginBottom: "0.5rem"
            }}>Henüz analiz kaydı bulunmamaktadır</h3>
            <p style={{
              color: "#6b7280",
              marginBottom: "1.5rem"
            }}>İşletmenizin Vayz analizini görüntülemek için yeterli veri bulunmamaktadır.</p>

          </div>
        </div>
      )}
    </>
  );
};

export default AnalysisIndex;
